import * as Sentry from '@sentry/browser';

import packageInfo from '../../package.json';

// This is our project dsn
const dsn = 'https://3594f287200410a42d2a8cd949cde4d7@o354215.ingest.sentry.io/4505986015887360';

export const initializeSentry = () => {
  Sentry.init({
    dsn: dsn,
    tracesSampleRate: 1.0,
    environment: process.env.REACT_APP_ENV,
    release: `autoshipment-central-hub-front@${packageInfo.version}`,
  });
  Sentry.getCurrentScope().setTag('version', packageInfo.version || 'undefined');
};

export const withSentryHub = () => {
  if (!Sentry) {
    initializeSentry();
  }
  return Sentry;
};
